// removed by extract-text-webpack-plugin
module.exports = {"wrap":"search-UserBanner-wrap","group":"search-UserBanner-group","secondPart":"search-UserBanner-secondPart","block":"search-UserBanner-block","twisted":"search-UserBanner-twisted","twistedPart":"search-UserBanner-twistedPart","submitBlock":"search-UserBanner-submitBlock","row":"search-UserBanner-row","message":"search-UserBanner-message","fromPart":"search-UserBanner-fromPart","inputsBlock":"search-UserBanner-inputsBlock","error":"search-UserBanner-error","submit":"search-UserBanner-submit"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/UserBanner/index.css
// module id = 1837
// module chunks = 0